export const miscTailHc = {
  maquetaCreateNav: {
    guidesAria: "Video guides and help",
    guidesTip: "Guides and help",
    availabilityPricesTitle: "Availability & Rates",
    hotelCalendarSubtitle: "Availability and bookings by room",
    availabilityPricesSubtitle: "Prices, availability and minimum stay",
  },
  maquetaNav: {
    guidesAria: "Video guides and help",
    guidesTip: "Guides and help",
    novedadesAria: "System updates",
    novedadesTip: "What's new",
    tourTip: "What's new: guided tour",
    tourAria: "Open the what's new tour",
    backToPanel: "Back to panel",
    accountTitle: "Account settings",
    agentIaTitle: "AI Agent",
    directBookingsTitle: "Direct bookings",
    listingsTitle: "Listings settings",
  },
  navMovil: {
    menuTitle: "Menu",
    home: "Home",
    calendar: "Calendar",
    reservations: "Reservations",
    checkins: "Check-ins",
    housekeeping: "Housekeeping",
    channels: "Booking channels",
    settings: "Settings",
    settingsDesktopOnly: "Available only in the desktop version",
    experiences: "Experiences",
  },
  register: {
    terms: "Terms",
    privacy: "Privacy policy",
    loginError: "Error signing in.",
  },
  buttonSave: {
    savingRoom: "Saving room...",
  },
  firstForm: {
    name: "First name",
    phone: "Phone",
  },
  final: {
    guestsRegistered: "Registered guests",
    registrationsCompleted: "Completed registrations",
    registrationTime: "Registration time: ",
    shareRegistrationLink: "Share registration link",
  },
  scannerPdf417: {
    captureCode: "Capture code",
    focusInstruction: "Focus and capture the barcode on your ID",
  },
  configNotifications: {
    title: "Notifications",
    propertyLabel: "Property",
    phoneInstruction: "Enter the phone number you want to use to receive notifications of service requests or check-ins made by guests via WhatsApp",
    saveWhatsapp: "Save WhatsApp",
    editWhatsapp: "Edit WhatsApp",
    configTitle: "Settings",
    serviceNotifications: "Service notifications",
    checkinNotifications: "Check-in notifications",
    active: "On",
    inactive: "Off",
    whatsappRequired: "You must enter the WhatsApp number",
    swalTitle: "WhatsApp for your property's notifications",
    swalText: "You'll receive all notifications about requested services and guest check-ins ",
    cancel: "Cancel",
    whatsappAdded: "WhatsApp added successfully",
  },
  modalPoliceData: {
    headerSub: "Enter your system access credentials",
    closeAria: "Close",
    entityName: "Entity name",
    usernamePlaceholder: "Enter your username",
    passwordPlaceholder: "Enter your password",
    hide: "Hide",
    show: "Show",
    lessorExample: "e.g. 12345",
    establishmentExample: "e.g. 67890",
    saving: "Saving…",
    listingNotFound: "The associated listing was not found.",
    saveFailed: "SES Hospedajes could not be saved.",
  },
  notificaciones: {
    title: "Notifications",
    propertyLabel: "Property",
    phoneInstruction: "Enter the phone number you want to use to receive notifications of service requests or check-ins made by guests via WhatsApp",
    saveWhatsapp: "Save WhatsApp",
    editWhatsapp: "Edit WhatsApp",
    configTitle: "Settings",
    serviceNotifications: "Service notifications",
    checkinNotifications: "Check-in notifications",
    active: "On",
    inactive: "Off",
    whatsappRequired: "You must enter the WhatsApp number",
    swalTitle: "WhatsApp for your property's notifications",
    swalText: "You'll receive all notifications about requested services and guest check-ins ",
    cancel: "Cancel",
    whatsappAdded: "WhatsApp added successfully",
  },
  admins: {
    listTitle: "Managers list",
    newManager: "New manager",
    today: "Today",
    thName: "Name",
    thEmail: "Email",
    thRegistered: "Registered",
    edit: "Edit",
    delete: "Delete",
    userLabel: "Username",
    emailLabel: "Email",
    passwordLabel: "Password",
    cancel: "Cancel",
    save: "Save",
    createdOk: "Created successfully",
    requestError: "Request error",
    updatedOk: "Updated successfully",
    deletedOk: "Deleted successfully",
  },
};
